export default __webpack_public_path__ + "static/media/2-aplicacoes.728a1e61.svg";